<template>
    <Card>
        <Row :gutter="16">
            <Col span="24">
            <div class="global-tool-bar">
                <div class="left-bar">
                    <span class="title">投诉建议管理</span>
                </div>
                <div class="right-bar">
                    <!-- <Button class="btns"
                        shape="circle"
                        type="success"
                        icon="ios-add-circle-outline"
                        @click="onSuggestionCreate">新增</Button> -->
                </div>
            </div>
            </Col>
        </Row>

        <Row v-if="suggestionFormShow"
            :gutter="16">
            <Form :label-width="80"
                label-position="right">
                <!-- <Col span="6">
                <FormItem label="投诉主题">
                    <Input v-model="suggestionForm.suggestionTitle"
                        readonly></Input>
                </FormItem>
                </Col> -->
                <!-- <Col span="6">
                <FormItem label="投诉类型">
                    <Input v-model="suggestionForm.suggestionType"
                        readonly></Input>
                </FormItem>
                </Col> -->
                <Col span="8">
                <FormItem label="详细内容">
                    <Input v-model="suggestionForm.suggestionDetail"
                        readonly></Input>
                </FormItem>
                </Col>
                <Col span="4">
                <FormItem label="相关图片">
                    <Button v-if="suggestionForm.suggestionImages !== ''"
                        type="info"
                        @click="onShowImage(suggestionForm.suggestionImages)">查看</Button>
                </FormItem>
                </Col>
                <Col span="20">
                <FormItem label="回复内容">
                    <Input v-model="suggestionForm.suggestionReplayDetail"></Input>
                </FormItem>
                </Col>
                <Col span="4">
                <Button type="success"
                    class="form-button"
                    @click="onSave">保存</Button>
                <Button type="text"
                    class="form-button"
                    @click="onCancel">取消</Button>
                </Col>
            </Form>
        </Row>

        <Row :gutter="16">
            <Col span="24">
            <stand-pagination-table :columns="mainTable.columns"
                :data="mainTable.data"
                :loading="mainTable.loading"
                :table-search="mainTable.tableSearch"
                :table-load-event="getSuggestionTableRecords" />
            </Col>
        </Row>
    </Card>
</template>

<script>
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { FORM_EDIT_MODE_CREATE, FORM_EDIT_MODE_MODIFY } from '@/view/mixins/form-edit-mode';
import { dateTimeRender } from '@/libs/tableRowTimeRender';
import { getImageSrc } from '@/libs/tableRowImageRender';
import { getSuggestionList, saveSuggestion } from '@/api/modules/system-management/suggestion-management';

export default {
    name: 'SuggestionList',
    components: {
        StandPaginationTable
    },
    data() {
        return {
            suggestionForm: {
                formEditMode: '',
                suggestionUuid: '',
                // suggestionTitle: '',
                // suggestionType: '',
                suggestionDetail: '',
                suggestionImages: '',
                suggestionCreatorUuid: '',
                suggestionCreator: '',
                suggestionStatus: '',
                suggestionCreatedAt: '',
                suggestionReplyPersonUuid: '',
                suggestionReplyPersonName: '',
                suggestionReplayDetail: '',
                suggestionRepliedAt: ''
            },
            suggestionFormShow: false,
            mainTable: {
                columns: [
                    { title: '行号', type: 'index', width: 80, align: 'center' },
                    // { title: '主题', key: 'suggestionTitle', align: 'center' },
                    // { title: '类型', key: 'suggestionType', align: 'center' },
                    { title: '投诉建议内容', key: 'suggestionDetail', align: 'center' },
                    { title: '发起人', key: 'suggestionCreator', align: 'center' },
                    { title: '发起时间', key: 'suggestionCreatedAt', align: 'center', render: (h, params) => dateTimeRender(h, params.row.suggestionCreatedAt) },
                    {
                        title: '状态',
                        key: 'suggestionStatus',
                        align: 'center',
                        render: (h, params) => {
                            let text = '';
                            if (params.row.suggestionStatus === -1) {
                                text = '已撤回';
                            }
                            else if (params.row.suggestionStatus === 0) {
                                text = '已发起';
                            }
                            else if (params.row.suggestionStatus === 1) {
                                text = '已回复';
                            }
                            else {
                                text = '未知';
                            }
                            return h('div', [
                                h('span', {
                                    style: {}
                                }, text)]);
                        }
                    },
                    { title: '回复人', key: 'suggestionReplyPersonName', align: 'center' },
                    { title: '回复时间', key: 'suggestionRepliedAt', align: 'center', render: (h, params) => dateTimeRender(h, params.row.suggestionRepliedAt) },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style: {},
                                    on: {
                                        click: () => {
                                            this.onSuggestionUpdate(params.row);
                                        }
                                    }
                                }, '回复')]);
                        }
                    }
                ],
                data: [],
                sarchCardShow: false,
                searchForm: [],
                loading: false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    mounted() {
        this.getSuggestionTableRecords();
    },
    methods: {
        onShowImage(image) {
            const imageSrc = getImageSrc(image);
            if (imageSrc) {
                window.open(imageSrc);
            }
        },
        getSuggestionTableRecords(reset = false) {
            this.mainTable.tableLoading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            getSuggestionList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.data = res.data.records;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }

                this.mainTable.tableLoading = false;
            }).catch(() => {
                this.mainTable.tableLoading = false;
            });
        },
        onSuggestionCreate() {
            this.suggestionForm.formEditMode = FORM_EDIT_MODE_CREATE;
            this.suggestionForm.suggestionUuid = '';
            // this.suggestionForm.suggestionTitle = '';
            // this.suggestionForm.suggestionType = '';
            this.suggestionForm.suggestionDetail = '';
            this.suggestionFormShow = true;
        },
        onSuggestionUpdate(row) {
            Object.assign(this.suggestionForm, row);
            this.suggestionForm.formEditMode = FORM_EDIT_MODE_MODIFY;
            this.suggestionFormShow = true;
        },
        onCancel() {
            this.suggestionFormShow = false;
        },
        onSave() {
            const data = Object.assign({}, this.suggestionForm);
            saveSuggestion(data).then(res => {
                if (res.code === 0) {
                    this.$Modal.success({
                        title: '保存成功',
                        onOk: () => {
                            this.suggestionFormShow = false;
                            this.getSuggestionTableRecords();
                        }
                    });
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
.form-button {
    margin-top: 5px;
}
</style>
